import {
  setAccountInformationInq,
  setAccountRayaSavingExist,
  setAcctCreatedFromSaving,
  setAppInqRes,
  setAppInqResV3,
  setApplicationStatus,
  setApprovalDetails,
  setBankCode,
  setBriAccountNumber,
  setCustomerName,
  setEktp,
  setIncompleteApp,
  setIsCompanyUpdated,
  setIsCustomerConsent,
  setIsTncAgreement,
  setIsUsingForm,
  setRayaAccountName,
  setRayaAccountNumber,
  setRegistrationStatus,
  setRegistrationStatusIncoming,
  setSecondApply,
  setUpdateAgreement,
  setApplicationStatusV3,
  setApplicationIdV3,
  setEligibleMgm,
  setCompanyName
} from 'store/actions';

const setupAccountInformation = (dispatch, info) => {
  dispatch(setAccountInformationInq(info));
  if (info.registrationRayaSavingStatus)
    dispatch(setRegistrationStatus(info.registrationRayaSavingStatus));
  if (info.registrationRayaSavingStatusIncoming)
    dispatch(
      setRegistrationStatusIncoming(info.registrationRayaSavingStatusIncoming)
    );
  if (info.acctRayaSavingExist)
    dispatch(setAccountRayaSavingExist(info.acctRayaSavingExist));
  if (info.payrollAccountNumber)
    dispatch(setBriAccountNumber(info.payrollAccountNumber));
  if (info.disbursementAccountNumber)
    dispatch(setRayaAccountNumber(info.disbursementAccountNumber));
  if (info.accountNameRaya) dispatch(setRayaAccountName(info.accountNameRaya));
  if (info.acctCreatedFromSaving)
    dispatch(setAcctCreatedFromSaving(info.acctCreatedFromSaving));
};

/**
 * to handle common dispatch from application inquiry response
 * @param {*} dispatch
 * @param {*} data
 */
export const setupCommonDispatch = (dispatch, data) => {
  dispatch(setApplicationStatus(data?.applicationStatus?.cmCode));
  dispatch(setApplicationStatusV3(data?.suplesiData?.applicationStatus));
  dispatch(setApplicationIdV3(data?.suplesiData?.applicationId));
  dispatch(setAppInqRes(data));

  if (data.ktpNum) dispatch(setEktp(data.ktpNum));
  if (data.approvalDetails) {
    dispatch(setApprovalDetails(data.approvalDetails));
    dispatch(setCustomerName(data.approvalDetails.nama));
  }
  if (data.incompleteApplicationDetails)
    dispatch(setIncompleteApp(data.incompleteApplicationDetails));

  dispatch(setSecondApply(data?.isSecondApply));
  if (data.isCompanyUpdated)
    dispatch(setIsCompanyUpdated(data.isCompanyUpdated));
  if (data.isCustomerConsentAgreement)
    dispatch(setIsCustomerConsent(data.isCustomerConsentAgreement));
  if (data.isUsingForm) dispatch(setIsUsingForm(data.isUsingForm));
  if (data.bankCode) dispatch(setBankCode(data.bankCode));
  if (data.payrollDetails)
    dispatch(setCompanyName(data.payrollDetails.companyName));

  const isTncAgreement = data.isTncAgreement || '';
  if (!isTncAgreement || isTncAgreement !== 'Y') {
    dispatch(setIsTncAgreement(isTncAgreement));
    dispatch(setUpdateAgreement(true));
  } else {
    dispatch(setIsTncAgreement(isTncAgreement));
  }

  if (data.accountInformation)
    setupAccountInformation(dispatch, data.accountInformation);

  dispatch(setEligibleMgm(data?.eligibleMgm));
};

/**
 * to handle common dispatch from application inquiry response
 * @param {*} dispatch
 * @param {*} data
 */
export const setupCommonDispatchV3 = (dispatch, data) => {
  dispatch(setApplicationStatusV3(data?.applicationStatusSuplesi?.cmCode));
  dispatch(setApplicationIdV3(data?.applicationIdSuplesi));
  dispatch(setAppInqResV3(data));
  if (data.payrollDetails)
    dispatch(setCompanyName(data.payrollDetails.companyName));
};
